/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useIntl } from 'react-intl'
import React from 'react'

import { useFlagsWhenLoaded } from '@modules/launchdarkly'

import BaseFeatureCard from './BaseFeatureCard'

import type { ComponentProps, FC } from 'react'

const ElasticInferenceServiceCard: FC<Pick<ComponentProps<typeof BaseFeatureCard>, 'onNext'>> = ({
  onNext,
}) => {
  const { formatMessage } = useIntl()

  const [, flags] = useFlagsWhenLoaded()

  const { isElasticInferenceServiceEnabled } = flags

  return (
    <BaseFeatureCard
      title='Elastic Inference Service'
      description={formatMessage({
        id: 'eis.description',
        defaultMessage: 'Use Elastic Cloud inference service',
      })}
      features={[
        'Feature 1: Automated scaling',
        'Feature 2: Intelligent monitoring',
        'Feature 3: Predictive maintenance',
      ]}
      nextStepLabel={formatMessage({
        id: 'eis.nextStepLabel',
        defaultMessage: `I'm interested`,
      })}
      onNext={onNext}
      dataAttributePrefix='eis'
      isComingSoon={!isElasticInferenceServiceEnabled}
    />
  )
}

export default ElasticInferenceServiceCard
